export enum OptionGroupSelectionType {
  multiSelect = 'multiSelect',
  singleSelect = 'singleSelect',
}
export interface Location {
  venue: string;
  venueName: string;
  section: string;
  sectionName: string;
  collectionPoint: string;
  collectionPointName: string;
  seat: string;
  row: string;
}
export enum PatronOrderStatus {
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  RECEIVED = 'RECEIVED',
  PREPARING = 'PREPARING',
  PREPARED = 'PREPARED',
  PARTIALLY_ASSIGNED = 'PARTIALLY_ASSIGNED',
  ASSIGNED = 'ASSIGNED',
  DELIVERED = 'DELIVERED',
  REJECTED = 'REJECTED',
  REFUNDED = 'REFUNDED',
}
export interface OrderPatron {
  _id: string;
  name: string;
  phoneNumber: string;
}

export interface OrderCharges {
  markUpRate: number;
  deliveryCharge: number;
  stripeFee: number;
}

export interface OrderVendor {
  _id: string;
  tradingName: string;
  phoneNumber: string;
}

export interface OrderPatron {
  _id: string;
  name: string;
  phoneNumber: string;
}

export interface OrderRunner {
  _id: string;
  name: string;
  phoneNumber: string;
}

export enum PaymentStatus {
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  PAYMENT_AUTHORISED = 'PAYMENT_AUTHORISED',
  PAYMENT_CAPTURED = 'PAYMENT_CAPTURED',
  PAYMENT_CANCELLED = 'PAYMENT_CANCELLED',
}

export enum ServiceMethod {
  DELIVERY = 'DELIVERY',
  COLLECTION_POINT = 'COLLECTION_POINT',
  COLLECT_FROM_VENDOR = 'COLLECT_FROM_VENDOR',
  VENDOR_DELIVERY = 'VENDOR_DELIVERY',
  ROOM_SERVICE = 'ROOM_SERVICE',
  TABLE_SERVICE = 'TABLE_SERVICE',
}
export interface PatronOrder {
  _id: string;
  patron?: OrderPatron;
  orderStatus: PatronOrderStatus;
  location: Location;
  vendorOrders: VendorOrder[];
  pricing: Pricing;
  paymentIntentId: string;
  paymentIntentClientSecret: string;
  charges?: OrderCharges;
  paymentStatus: PaymentStatus;
  orderNumber: string;
  createdAt: Date;
  updatedAt: Date;
  isDeleted?: boolean;
  serviceMethod: ServiceMethod;
  isClickAndCollectEnabled: boolean;
}

export enum RefundStatus {
  RAISED = 'RAISED',
  PROCESSING = 'PROCESSING',
  DENIED = 'DENIED',
  PARTIALLY_REFUNDED = 'PARTIALLY_REFUNDED',
  REFUNDED = 'REFUNDED',
}

export interface IssueDescription {
  refundReason: string;
  reportorComments?: string[];
  reviewerComments?: string[];
}

export interface RefundItem {
  id: string;
  price: number;
  quantity: number;
  refundQuantity?: number;
}

export interface RefundOrder {
  _id: string;
  orderNumber: string;
  orderId: string;
  patronId: string;
  patron: OrderPatron;
  amountRequested: number;
  amountRefunded?: number;
  refundStatus: RefundStatus;
  issueDescription: IssueDescription;
  openDate: Date;
  closeDate?: Date;
  requestedRefundItems?: RefundItem[];
  finalRefundItems?: RefundItem[];
  transactionId?: string;
}

export interface OptionWithType {
  _id: string;
  name: string;
  description: string;
  optionGroupID: string;
  type?: OptionGroupSelectionType;
  price?: number;
  markupPrice?: number;
}

export interface OrderedItem {
  _id: string;
  name: string;
  price: number;
  markupPrice: number;
  count: number;
  updatedQuantity?: number;
  isUpdated?: boolean;
  isRejected?: boolean;
  customisations?: OrderedItemOption[];
}

export interface OrderedItemOption {
  _id: string;
  name: string;
  price: number;
  markupPrice: number;
}

export type OrderStatusHistory = {
  status: string;
  createdAt: string;
  userType: string;
  message: string;
};
export interface VendorOrder {
  _id: string;
  orderStatus: OrderStatus;
  patronOrderID: string;
  items: OrderedItem[];
  isPaymentComplete: boolean;
  pricing?: Pricing;
  patronOrder?: PatronOrder;
  runner?: OrderRunner;
  patron?: OrderPatron;
  vendor?: OrderVendor;
  options?: OptionWithType[];
  orderNumber: string;
  createdAt?: Date;
  updatedAt?: Date;
  isOrderUpdated?: boolean;
  isDeleted?: boolean;
  isClickAndCollectEnabled: boolean;
  history: OrderStatusHistory[];
  paymentDetails? : {
    status: PaymentStatus;
  }
}
export enum OrderStatus {
  RECEIVED = 'RECEIVED',
  ACCEPTED = 'ACCEPTED',
  ASSIGNED = 'ASSIGNED',
  REJECTED = 'REJECTED',
  PATRON_CANCELLED = 'PATRON_CANCELLED',
  ADMIN_CANCELLED = 'ADMIN_CANCELLED',
  PREPARING = 'PREPARING',
  PREPARED = 'PREPARED',
  PICKED = 'PICKED',
  COMPLETE = 'COMPLETE',
  REFUNDED = 'REFUNDED',
  ASSIGNED_BUT_PREPARING = 'ASSIGNED_BUT_PREPARING',
}
export interface OrderedItems {
  itemID: string;
  count: number;
  customisations: string[];
}

export interface Pricing {
  subTotal: number;
  deliveryCharge: number;
  total: number;
}
